import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fxmediaLogo from "../../assets/icons/fxmedia-logo.png";
import axios from "axios";
import { login } from "../../auth/auth";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LandingPage = () => {
  const [authToken, setAuthToken] = useState("");
  const [avatars, setAvatars] = useState([]);
  const [passphrase, setPassphrase] = useState("$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
  const [activeButton, setActiveButton] = useState("All");

  const navigate = useNavigate();

  // remove the max-width
  useEffect(() => {
    sessionStorage.clear();
    const originalBodyStyles = {
      maxWidth: document.body.style.maxWidth,
    };
    document.body.style.maxWidth = "none";
    return () => {
      document.body.style.maxWidth = originalBodyStyles.maxWidth;
    };
  }, []);
  // end of remove the max-width

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  useEffect(() => {
    const fetchAvatars = async () => {
      if (!authToken) return;

      try {
        // Fetch avatars based on the active passphrase or fetch all avatars when "All" is selected
        let passphrasesToFetch = [];
        if (activeButton === "All") {
          passphrasesToFetch = [
            "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe", // Star
            "JkOACSfNY6xSX6PV8241EdATjeIcKWXzKAxB", // Medical
            "LVTrOE9QY53xJiLqDcmjBk9soxoFGCN5hbtn", // Education
          ];
        } else {
          passphrasesToFetch = [passphrase]; // Only fetch the avatars for the selected passphrase
        }

        const avatarsData = [];
        for (const pass of passphrasesToFetch) {
          const { data } = await axios.get(
            `${BASE_URL}/api/avatar/passphrase/${pass}`,
            {
              headers: { Authorization: `Bearer ${authToken}` },
            }
          );
          avatarsData.push(...(data.data || []));
        }

        setAvatars(avatarsData);
      } catch {
        // Handle error silently or add an optional error state
      }
    };

    fetchAvatars();
  }, [authToken, passphrase, activeButton]);

  const handleButtonClick = (category) => {
    setActiveButton(category);
    switch (category) {
      case "Star":
        setPassphrase("$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
        break;
      case "Medical":
        setPassphrase("JkOACSfNY6xSX6PV8241EdATjeIcKWXzKAxB");
        break;
      case "Education":
        setPassphrase("LVTrOE9QY53xJiLqDcmjBk9soxoFGCN5hbtn");
        break;
      default:
        setPassphrase("$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
        break;
    }
  };

  const handleRedirect = (avatar) => {
    let redirectPath = "";

    if (avatar.key.name === "FXMedia") {
      redirectPath = `/avatar/${avatar.name}`;
    } else if (avatar.key.name === "AI Avatar for Education") {
      redirectPath = `/classroom/${avatar.name}`;
    } else if (avatar.key.name === "AI AVATAR MEDICAL") {
      redirectPath = `/hospital/${avatar.name}`;
    }

    navigate(redirectPath);
  };

  const ListAvatar = () => {
    return (
      <div className="landing__page--content">
        {avatars.map(
          (avatar) => (
            console.log("avatar id", avatar.id),
            console.log("avatar name", avatar.name),
            console.log("avatar topic", avatar.key.name),
            (
              <div
                className="landing__page--avatar"
                key={avatar.id}
                onClick={() => handleRedirect(avatar)}
              >
                <div className="landing__page--avatar-img">
                  <img src={`${BASE_URL}${avatar.hyperlink}`} alt="" />
                </div>
                <div className="landing__page--avatar-name">
                  <p>{avatar.name}</p>
                </div>
              </div>
            )
          )
        )}
      </div>
    );
  };

  return (
    <div className="landing__page">
      <div className="landing__page--logo">
        <img src={fxmediaLogo} alt="fxmedia logo" />
      </div>
      <div className="landing__page--container">
        <div className="landing__page--topic-btn">
          <button
            className={activeButton === "All" ? "active" : ""}
            onClick={() => handleButtonClick("All")}
          >
            All
          </button>
          <button
            className={activeButton === "Star" ? "active" : ""}
            onClick={() => handleButtonClick("Star")}
          >
            Star Enterprise
          </button>
          <button
            className={activeButton === "Medical" ? "active" : ""}
            onClick={() => handleButtonClick("Medical")}
          >
            Medical
          </button>
          <button
            className={activeButton === "Education" ? "active" : ""}
            onClick={() => handleButtonClick("Education")}
          >
            Education
          </button>
        </div>
        <ListAvatar />
      </div>
    </div>
  );
};

export default LandingPage;
